import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    appliedFilters: null,
    screen_name: null,
    selectedFilters: null,
    hasUserApplied: false,
}

const filterSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        applyFilters: (state, action) => {
            state.appliedFilters = action.payload;
            state.screen_name = action.payload.screen_name || state.screen_name;
            state.selectedFilters = action.payload.selectedFilters;
            state.hasUserApplied = true;
        },
        resetFilters: (state) => {
            // state.appliedFilters = null;
            return initialState
        }
    },
})

export const { applyFilters, resetFilters } = filterSlice.actions;

export default filterSlice.reducer;